<div class="payment-plan-summary" [class.payment-plan-summary--error]="error">
  @if (error) {
<div>Unable to calculate as entered</div>
}

  @if (!error) {

    @if (upfrontAmountOption === 'fullAmount') {
<div>
      Full price due up front, not eligible for payment plans
    </div>
}
    @if (upfrontAmountOption !== 'fullAmount') {
<div>
      Default price is {{upfrontAmount}} due up front, remainder due per payment plan
    </div>
}
    @if (priceVariations?.length > 0) {
<div>
      Default price is
      {{upfrontAmountOption === 'fullAmount' ? upfrontAmount : ('$' + (getDefaultPrice() | number:'1.2-2'))}}
    </div>
}
    @for (priceVariation of priceVariations; track priceVariation) {

      @if (priceVariation.valid) {
<div>
        {{priceVariation.value.pricing_name}} (${{priceVariation.value.price_cents}}) is
        {{priceVariation.value.start_date | date:'MMM d, y'}}–{{priceVariation.value.end_date | date:'MMM d, y'}}
      </div>
}

}

}
</div>
